/**
 * Personal / sensitive tab URLs — never shown in Live tracking.
 * Keep in sync with internal/privacy/personal_tab.go
 */

const PERSONAL_TAB_DOMAINS = [
  'gmail.com',
  'googlemail.com',
  'outlook.com',
  'outlook.live.com',
  'hotmail.com',
  'live.com',
  'mail.yahoo.com',
  'yahoo.com',
  'proton.me',
  'protonmail.com',
  'icloud.com',
  'fastmail.com',
  'zoho.com',
  'meet.google.com',
  'zoom.us',
  'zoom.com',
  'teams.microsoft.com',
  'webex.com',
  'whereby.com',
  'gotomeeting.com',
  'bluejeans.com',
  'ringcentral.com',
  'dialpad.com',
  '8x8.com',
  'messenger.com',
  'web.whatsapp.com',
  'web.telegram.org',
  'signal.org',
  'chase.com',
  'wellsfargo.com',
  'bankofamerica.com',
  'citi.com',
  'capitalone.com',
  'usbank.com',
  'pnc.com',
  'td.com',
  'americanexpress.com',
  'discover.com',
  'paypal.com',
  'venmo.com',
  'zellepay.com',
  'stripe.com',
  'squareup.com',
  'robinhood.com',
  'coinbase.com',
  'binance.com',
  'kraken.com',
  'fidelity.com',
  'schwab.com',
  'vanguard.com',
  'etrade.com',
  'mint.com',
  'creditkarma.com',
  'plaid.com',
  'accounts.google.com',
  'myaccount.google.com',
  'account.microsoft.com',
  'appleid.apple.com',
  'lastpass.com',
  '1password.com',
  'bitwarden.com',
  'dashlane.com',
  'mychart.org',
  'patientportal.com',
] as const;

const PERSONAL_HOST_FRAGMENTS = [
  'bank',
  'banking',
  'creditunion',
  'cu.org',
  'onlinebanking',
  'netbank',
];

const PERSONAL_PATH_FRAGMENTS = [
  '/mail/',
  '/webmail',
  '/onlinebanking',
  '/internetbanking',
  '/retailbanking',
  '/personal-banking',
];

function hostMatchesPersonal(hostname: string): boolean {
  const host = hostname.toLowerCase().replace(/^www\./, '');
  for (const domain of PERSONAL_TAB_DOMAINS) {
    if (host === domain || host.endsWith('.' + domain)) return true;
  }
  const fragmentsWithoutLocalhost = PERSONAL_HOST_FRAGMENTS.filter(f => f !== 'localhost' && f !== '127.0.0.1');
  return fragmentsWithoutLocalhost.some((frag) => host.includes(frag));
}

/** True when a URL should be excluded from tab tracking (email, banking, meetings, etc.). */
export function isPersonalOrSensitiveUrl(url: string): boolean {
  if (!url?.trim()) return false;
  try {
    const parsed = new URL(url);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return false;
    if (hostMatchesPersonal(parsed.hostname)) return true;
    const path = parsed.pathname.toLowerCase();
    if (PERSONAL_PATH_FRAGMENTS.some((frag) => path.includes(frag))) return true;
    if (
      (path.includes('/signin') || path.includes('/login')) &&
      (parsed.hostname.includes('bank') ||
        parsed.hostname.includes('pay') ||
        parsed.hostname.includes('mail') ||
        parsed.hostname.includes('account'))
    ) {
      return true;
    }
    return false;
  } catch {
    const lower = url.toLowerCase();
    const fragmentsWithoutLocalhost = PERSONAL_HOST_FRAGMENTS.filter(f => f !== 'localhost' && f !== '127.0.0.1');
    return fragmentsWithoutLocalhost.some((f) => lower.includes(f));
  }
}
